// removed by extract-text-webpack-plugin
module.exports = {"container":"G4NFU","facebook-container":"_3uD37"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemShareAlert/RichUpdatesItemShareAlert.scss
// module id = ./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemShareAlert/RichUpdatesItemShareAlert.scss
// module chunks = 5